import React from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../lib/firebase";
import { signOut } from "firebase/auth";

export default function Header() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  return (
    <div className="w-full bg-[#f7adc4] text-white flex items-center justify-between px-2 sm:px-4 py-2 sm:py-4">
      <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
        <img src="/1.png" alt="Logo" className="h-auto w-auto max-h-[40px] sm:max-h-[50px] md:max-h-[60px] flex-shrink-0" />
        <h1 className="font-semibold tracking-wide text-sm sm:text-lg md:text-xl lg:text-[25px] whitespace-nowrap">
          Tax Help, Made Simple
        </h1>
      </div>
      <div className="flex-shrink-0">
        <button
          onClick={handleLogout}
          className="text-xs sm:text-sm font-bold hover:underline whitespace-nowrap"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
